import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConfirmationModalSystem from '../../DesignSystem/ConfirmationModalSystem';
import useConfigurationPermissions from '../../../hooks/useConfigurationPermissions';
import { useProjectActions } from '../../../hooks/useProjectActions';

const UnarchiveProjectModal = ({ t, visible, setVisible }) => {
  const projectState = useSelector((state) => state.projectState);
  const [currentProject, setCurrentProject] = useState({});
  const permissions = useConfigurationPermissions();
  const { unarchiveProject } = useProjectActions();

  useEffect(() => {
    setCurrentProject(projectState.props.currentProject);
  }, [projectState.props.currentProject]);

  const handleUnarchive = async () => {
    await unarchiveProject(currentProject);
  };

  if (permissions.project !== 'AC') {
    return null;
  }

  return (
    <ConfirmationModalSystem
      visible={visible}
      setVisible={setVisible}
      message={t('project_unarchive.message', {
        projectName: currentProject?.name
      })}
      phrase={t('project_unarchive.phrase')}
      confirmButtonText={t('project_unarchive.confirm_button')}
      onConfirm={handleUnarchive}
    />
  );
};

UnarchiveProjectModal.propTypes = {
  t: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired
};

export default withTranslation()(UnarchiveProjectModal);
